<template>
  <div class="deposit-refund-bd payment-msg-bill">
    <custom-dialog
      :title="title"
      width="1400px"
      :visible="visible"
      :append-to-body="true"
      v-on="$listeners"
    >
      <div class="dialog-body refund-deposit-body">
        <div class="bill-deposit-confirm">
          <div class="bill-deposit-confirm-box">
            <div class="table-box">
              <!-- 选择需退押金设备 -->
              <bill-container
                :title="$t('fms_deposit_refund_dialog.xzxtyjdsb')"
                style="padding-bottom: 16px"
              >
                <div
                  slot="header"
                  class="header"
                >
                  <div class="btn-container">
                    <el-button
                      type="primary"
                      size="mini"
                      @click="onSelect"
                    >{{ $t('fms_deposit_refund_dialog.tian_jia_tui_kuan') }}</el-button>
                    <div class="money">
                      <div class="key">{{ $t('fms_deposit_refund_dialog.tkyjhj') }}：</div>
                      <div class="val">￥{{ deviceDepositTotal }}</div>
                    </div>
                  </div>
                </div>
                <custom-table
                  ref="table"
                  :data="deviceList"
                  tableCode="deposit_refund"
                  :filterArr="['payableOrgName']"
                >
                  <template v-slot:action="scope">
                    <el-button
                      type="text"
                      size="mini"
                      @click="del(scope.$index)"
                      :disabled="deviceList.length === 1"
                    >{{ $t('Common.com_delete') }}</el-button>
                  </template>
                </custom-table>
              </bill-container>
              <div style="padding: 16px">
                <el-form
                  :model="form"
                  :rules="rules"
                  ref="form"
                >
                  <el-row :gutter="10">
                    <el-col :span="6">
                      <el-form-item
                        :label="$t('fms_deposit_refund_dialog.sqtkfs')"
                        prop="refundMethod"
                      >
                        <custom-select
                          v-model="form.refundMethod"
                          code="refund_method"
                        ></custom-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="10"
                    v-if="form.refundMethod == 1"
                  >
                    <el-col :span="6">
                      <el-form-item
                        :label="$t('fms_deposit_refund_dialog.shou_kuan_zhang_hu')"
                        prop="receivableAccount"
                        class="is-required"
                      >
                        <custom-select
                          v-model="form.receivableAccount"
                          url="PartnerBankcardListByOrgId"
                          :params="{ orgId: device.payableOrgId }"
                          :props="{ label: 'name', value: 'depositNumber' }"
                          @change="changeBank"
                          :dataFilter="dataFilter"
                          ref="bank"
                        ></custom-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="*"
                        class="empty-label"
                        style="margin-left: 6px"
                      >
                        <!-- 产品说暂时去除该判断 -->
                        <el-button
                          class="add-bank"
                          @click="addBank"
                        >{{ $t('fms_deposit_refund_dialog.xzskyhk') }}</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="24">
                      <el-form-item
                        :label="$t('fms_deposit_refund_dialog.sqtkms')"
                        prop="refundDesc"
                        class="must"
                      >
                        <el-input
                          type="textarea"
                          :autosize="{ minRows: 4, maxRows: 8 }"
                          :placeholder="$t('fms_deposit_refund_dialog.qing_shu_ru_nei_rong')"
                          v-model="form.refundDesc"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="dialog-footer"
        slot="footer"
      >
        <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
        <el-button
          @click="onSubmit"
          type="primary"
        >{{ $t('Common.com_submit') }}</el-button>
      </div>
    </custom-dialog>
    <!-- 添加退款 -->
    <deposit-refund-select-dialog
      v-if="dialogVisible1"
      @close="dialogVisible1 = false"
      @confirm="onConfirm"
      :model="dialogModel1"
    ></deposit-refund-select-dialog>
    <!-- 添加银行卡 -->
    <add-bank-card-dialog
      v-if="dialogVisible2"
      @close="dialogVisible2 = false"
      :model="dialogModel2"
      @success="updateBankData"
    ></add-bank-card-dialog>
  </div>
</template>

<script>
// 申请退押金（申请退款）
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import addBankCardDialog from '@/pages/crm/components/bankCardDialog';
import billContainer from './bill_container';
import depositRefundSelectDialog from './deposit_refund_select_dialog.vue';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {
    billContainer,
    addBankCardDialog,
    depositRefundSelectDialog,
  },
  data() {
    return {
      device: {},
      deviceList: [],
      form: {
        billIdList: [],
        isSubmit: true,
        receivableAccount: '',
        receivableBank: '',
        receivableName: '',
        refundDesc: '',
        refundMethod: '',
      },
      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible2: false,
      dialogModel2: {},
    };
  },
  computed: {
    rules() {
      return {
        refundMethod: { required: true, message: this.$t('fms_deposit_refund_dialog.qxztkfs') },
        receivableAccount: { required: true, message: this.$t('fms_deposit_refund_dialog.qxzskzh') }
      };
    },
    title() {
      return this.model.title || this.$t('fms_deposit_refund_dialog.deng_ji_shou_kuan');
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    deviceDepositTotal() {
      return this.deviceList.reduce((total, item) => total + Number(item['paymentAmount'] || 0), 0);
    },
  },
  mounted() {
    this.device = this.model.data;
    this.deviceList = [this.model.data];
  },
  methods: {
    dataFilter(list) {
      list.forEach((item) => {
        const nameArr = [item.depositNumber, item.bankName, item.depositBank].filter(val => !!val);
        item.name = nameArr.join('/');
      });
      return list;
    },
    closeDialog() {
      this.visible = false;
    },
    onCancel() {
      this.closeDialog();
    },
    // 删除退押金
    del(index) {
      this.deviceList.splice(index, 1);
    },
    // 添加退押金
    onSelect() {
      this.dialogModel1 = {
        title: this.$t('fms_deposit_refund_dialog.tian_jia_tui_ya_jin'),
        data: {
          payableOrgId: this.deviceList[0]['payableOrgId'],
          receivableOrgId: this.deviceList[0]['receivableOrgId'],
          existBillIds: this.deviceList.map(t => `${t.billId}`).join(','),
        },
      };
      this.dialogVisible1 = true;
    },
    // 确认添加退押金
    onConfirm(rows) {
      this.deviceList = [...this.deviceList, ...rows];
    },
    // 添加银行卡
    addBank() {
      this.dialogModel2.type = 'add';
      this.dialogModel2.partnerOrgId = this.device.payableOrgId;
      this.dialogVisible2 = true;
    },
    // 选择银行卡
    changeBank(event) {
      this.form.receivableBank = event && event['depositBank'];
      this.form.receivableName = event && event['depositName'];
    },
    // 更新银行列表（新增后）
    updateBankData() {
      this.$refs.bank.getSelectList();
    },
    // 提交申请
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.form.billIdList = this.deviceList.map(t => t.billId);
        this.$postJSON(apis.DepositRefundApply, this.form).then((res) => {
          const bizId = res.data;
          const bizType = 'deposit_refund';
          this.$postJSON(`${apis.apsApproveApprovalApproveStart}/${bizType}/${bizId}`, {}, true).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            this.closeDialog();
            this.$emit('success');
          });
        });
      });
    },
  },
};
</script>

<style lang="scss">
.refund-deposit-body {
  padding: 0 !important;
  .empty-label .el-form-item__label {
    color: #ffffff;
  }
}
.bill-deposit-confirm {
  display: flex;
  flex-direction: column;
  height: 100%;
  .bill-deposit-confirm-box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    padding: 0px !important;
    .info-box {
      flex: 0 0 280px;
      width: 280px;
      padding: 0 24px;
      // margin-right: 24px;
      background-color: #f8f9fb;
      // height: 100%;
      .title {
        height: 60px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(57, 70, 104, 1);
        line-height: 60px;
      }
      .information {
        > li {
          padding: 8px 0 7px 0;
          border-bottom: 1px solid #eef2f7;
          .content {
            overflow: hidden;
            line-height: 18px;
            font-size: 12px;
            .key {
              width: 50%;
              float: left;
            }
            .val {
              float: right;
              width: 50%;
              text-align: right;
              word-break: break-all;
              .active-status {
                float: right;
                padding-left: 11px;
                position: relative;
                &.actived,
                &.no-active {
                  &::before {
                    $r: 5px;
                    content: ' ';
                    width: $r;
                    height: $r;
                    border-radius: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                    bottom: 0;
                    margin: auto;
                  }
                }
                &.actived {
                  &::before {
                    background: #0d9ae0;
                  }
                }
                &.no-active {
                  &::before {
                    background: #b3b3b3;
                  }
                }
              }
            }
          }
          .adress {
            margin-top: 6px;
            color: #98a6ad;
            line-height: 17px;
          }
        }
        .line-break {
          p {
            height: 40px;
            line-height: 40px;
            background: rgba(255, 255, 255, 0);
            font-size: 12px;
            color: rgba(108, 117, 125, 1);
          }
          span {
            font-size: 12px;
            color: rgba(152, 166, 173, 1);
            line-height: 17px;
            padding-bottom: 11px;
            border-bottom: 1px solid rgba(238, 242, 247, 1);
          }
        }
      }
      .device-num {
        height: 60px;
        font-size: 12px;
        font-weight: bold;
        color: rgba(73, 80, 87, 1);
        line-height: 60px;
        margin-top: 10px;
        span {
          float: right;
          height: 60px;
          font-size: 12px;
          font-weight: bold;
          color: rgba(73, 80, 87, 1);
          line-height: 60px;
        }
      }
      .device {
        .line {
          height: 36px;
          line-height: 36px;
          display: flex;
          .l {
            width: 60px;
            font-size: 12px;
            color: rgba(108, 117, 125, 1);
          }
          .progress {
            flex: 0 0 155px;
            margin: 0 auto;
            height: 6px;
            // line-height: 36px;
            .el-progress {
              padding: 11px 0;
              width: 155px;
            }
          }
          .right {
            height: 36px;
            font-size: 12px;
            color: rgba(108, 117, 125, 1);
            line-height: 36px;
          }
        }
      }
    }
    .table-box {
      padding: 24px;
      box-sizing: border-box;
      flex: 1;
      overflow-y: auto;
      .table-title {
        height: 60px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(73, 80, 87, 1);
        line-height: 60px;
      }
      .title {
        height: 40px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(57, 70, 104, 1);
        line-height: 40px;
      }
      .table-bd {
        height: 100%;
      }
    }
  }
}
</style>
